import React from 'react';
import { AnalyticsSource } from '@atlassian/jira-analytics-web-react/src/components/decorators.tsx';
import Spinner from '@atlassian/jira-common-components-spinner/src/view.tsx';
import { SCREEN } from '@atlassian/jira-product-analytics-bridge';
import {
	appBundleReadyMark,
	prefetchApiReadyMark,
} from '@atlassian/jira-providers-spa-apdex-analytics/src/marks';
import SubmitApdex from '@atlassian/jira-providers-spa-apdex-analytics/src/submit-apdex-mark/index.tsx';
import AddProjectToHistory from '@atlassian/jira-spa-apps-common/src/add-project-to-history';
import { PageLayout } from '@atlassian/jira-spa-apps-page-layout/src/page/index.tsx';
import { projectOpsgenieSchedulePageLoad } from '../utils/performance-analytics';
import type { Props } from './types';

function OpsgenieSchedule(props: Props) {
	const { Updater, OpsgenieScheduleApp, tenantContext, projectContext } = props;

	if (!(projectContext && projectContext.data && projectContext.data.projectKey)) {
		return <Spinner />;
	}

	const {
		isAdmin,
		baseUrl,
		locale,
		cloudId,
		atlassianAccountId: accountId,
		environment,
	} = tenantContext;
	const {
		projectId,
		projectKey,
		projectName,
		projectType,
		isProjectAdmin = false,
		simplified,
	} = projectContext.data;

	return (
		<PageLayout>
			<Updater />
			<OpsgenieScheduleApp
				{...{
					baseUrl,
					locale,
					isAdmin,
					cloudId,
					accountId,
					projectId,
					projectKey,
					projectName,
					projectType,
					simplified,
					environment,
					isProjectAdmin,
				}}
			/>
			{/* @ts-expect-error - TS2769 - No overload matches this call. */}
			<SubmitApdex
				metricKey="jira.project.opsgenie.schedule"
				metric={projectOpsgenieSchedulePageLoad}
				isExpectedToHaveSsr
				withMarks={[appBundleReadyMark, prefetchApiReadyMark]}
			/>
			<AddProjectToHistory baseUrl={baseUrl} projectKey={projectKey} />
		</PageLayout>
	);
}

export default AnalyticsSource('opsgenie-schedule', SCREEN)(OpsgenieSchedule);
